<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Tutorial Videos</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a></li>
                            <li class="breadcrumb-item active">Tutorial Videos</li>
                        </ol>
                    </div>
                </div>
            </div>
            <div class="content-header-right col-md-6 col-12 mb-md-0 mb-2">
                <button
                    @click.prevent="openAddModal"
                    type="button"
                    class="btn btn-outline-primary float-md-right"
                >
                    <i class="feather icon-plus icon-left"></i>
                    Add tutorial
                </button>
                <a
                    v-if="playlist && playlist.link"
                    :href="playlist.link"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="btn btn-primary float-md-right mr-1"
                >
                    <i class="feather icon-play-circle icon-left"></i>
                    Watch tutorial playlist
                </a>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>Tutorial Videos</h4>
                </div>
                <div class="card-body">
                    <vue-good-table
                        class="dataTable"
                        styleClass="vgt-table"
                        :columns="columns"
                        :rows="videos"
                        :pagination-options="paginationOptions"
                    >
                        <template slot="table-row" slot-scope="props">
                            <span v-if="props.column.field === 'sn'">
                                {{ props.index + 1 }}
                            </span>
                            <table-row-actions v-else-if="props.column.field === 'action'">
                                <a href="#" class="dropdown-item" @click.prevent="openEditModal(props.row)">
                                    <i class="feather icon-edit"></i> Edit
                                </a>
                                <a :href="props.row.link" target="_blank" rel="noopener noreferrer" class="dropdown-item">
                                    <i class="feather icon-play-circle"></i> Watch
                                </a>
                                <a href="#" class="dropdown-item text-danger" @click.prevent="showAlert(props.row.id)">
                                    <i class="feather icon-trash-2"></i> Delete
                                </a>
                            </table-row-actions>
                        </template>
                    </vue-good-table>
                </div>
            </section>
        </div>

        <div class="modal fade tutorial-video-modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <form @submit.prevent="saveTutorial">
                        <div class="modal-header">
                            <h4 class="modal-title">{{ isEditing ? 'Edit tutorial' : 'Add tutorial' }}</h4>
                            <button type="button" data-dismiss="modal" aria-label="Close" class="close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="form-group">
                                <label>Title</label>
                                <input type="text" class="form-control" v-model="form.title" required>
                                <span v-if="form.errors.title" class="text-danger text-small">{{ form.errors.title }}</span>
                            </div>
                            <div class="form-group">
                                <label>Description</label>
                                <textarea class="form-control" rows="3" v-model="form.description"></textarea>
                                <span v-if="form.errors.description" class="text-danger text-small">{{ form.errors.description }}</span>
                            </div>
                            <div class="form-group">
                                <label>Link</label>
                                <input type="url" class="form-control" v-model="form.link" placeholder="https://youtu.be/..." required>
                                <span v-if="form.errors.link" class="text-danger text-small">{{ form.errors.link }}</span>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn grey btn-outline-secondary" data-dismiss="modal">Close</button>
                            <button class="btn btn-primary" :disabled="saving">
                                {{ isEditing ? 'Update' : 'Save' }}
                                <i class="fa fa-spinner fa-spin" v-if="saving"></i>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import DeleteAlert from '../../Shared/Mixins/DeleteAlert';

export default {
    metaInfo: {title: 'Tutorial Videos'},
    layout: Layout,
    mixins: [DeleteAlert],
    props: {
        videos: {
            type: Array,
            default: () => [],
        },
        playlist: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            form: this.$inertia.form({
                id: null,
                title: '',
                description: '',
                link: '',
            }),
            isEditing: false,
            saving: false,
            paginationOptions: {
                enabled: true,
                perPage: 50,
                perPageDropdown: [10, 20, 50, 100],
            },
            columns: [
                {label: '#', field: 'sn', sortable: false},
                {label: 'Title', field: 'title'},
                {label: 'Description', field: 'description'},
                {label: 'Actions', field: 'action', sortable: false},
            ],
        };
    },
    methods: {
        resetForm() {
            this.form.id = null;
            this.form.title = '';
            this.form.description = '';
            this.form.link = '';
            this.form.clearErrors();
        },
        openAddModal() {
            this.isEditing = false;
            this.resetForm();
            $('.tutorial-video-modal').modal('show');
        },
        openEditModal(video) {
            this.isEditing = true;
            this.form.id = video.id;
            this.form.title = video.title;
            this.form.description = video.description || '';
            this.form.link = video.link;
            this.form.clearErrors();
            $('.tutorial-video-modal').modal('show');
        },
        saveTutorial() {
            this.saving = true;
            const options = {
                preserveScroll: true,
                onSuccess: () => {
                    this.saving = false;
                    $('.tutorial-video-modal').modal('hide');
                    this.resetForm();
                },
                onError: () => {
                    this.saving = false;
                },
            };

            if (this.isEditing) {
                this.form.put(route('admin.tutorial-videos.update', this.form.id), options);
                return;
            }

            this.form.post(route('admin.tutorial-videos.store'), options);
        },
        async showAlert(id) {
            const confirmed = await this.deleteAlert(
                'Are you sure you want to delete this tutorial?',
                "You won't be able to revert this!",
            );
            if (!confirmed) {
                return;
            }

            this.$inertia.delete(route('admin.tutorial-videos.delete', id), {
                preserveScroll: true,
            });
        },
    },
};
</script>
